import { getCategories } from "api";
import { QueryCacheConfig } from "common/constants";
import { useQuery } from "react-query";

export const useCategories = () => {
  return useQuery("categories", () => getCategories(true), {
    refetchOnWindowFocus: false,
    staleTime: QueryCacheConfig.STALE_TIME_LONG,
    cacheTime: QueryCacheConfig.CACHE_TIME_LONG,
  });
};
